export default "<app-shared-config-list></app-shared-config-list>\n";